export default __webpack_public_path__ + "static/media/stadisticsArmsUp.0baff597.svg";